import React, { useEffect, useState } from "react";
import Styles from "./BankingMain.module.css";
import SelfHeader from "./HeadingElements/SelfHeader";
import AvailableHeader from "./HeadingElements/AvailableHeader";
import AvailableListing from "./ListingContainer/AvailableListing/AvailableListing";
import SelfListing from "./ListingContainer/SelfListing/SelfListing";
import {
  fetchAllBankingListings,
  setActiveListingId,
} from "../../Redux/Slices/bankingSlice";
import { useDispatch, useSelector } from "react-redux";
import DamStrip from "../Modals/ConGen/Connection/DamStrip";
import { useSearchParams } from "react-router-dom";

const BankingMain = () => {
  const dispatch = useDispatch();
  const userType = useSelector((state) => state?.persistedReducer?.userType);
  const showDamStrip =
    userType === "CONSUMER" ||
    userType === "GENERATOR" ||
    userType === "BANKING";
  const [searchParams] = useSearchParams();
  const [expirySortDir, setExpirySortDir] = useState(null);
  const [activeFilter, setActiveFilter] = useState(() => {
    return sessionStorage.getItem("selfListingActiveFilter") || "ALL";
  });
  const [filteredSelfListings, setFilteredSelfListings] = useState([]);

  const [appliedFiltersMap, setAppliedFiltersMap] = useState({});
  const [filteredAvailableCount, setFilteredAvailableCount] = useState(0);

  const activeListingId = useSelector(
    (state) => state.bankingSlice.activeListingId,
  );

  const appliedFilters = appliedFiltersMap[activeListingId] || null;

  useEffect(() => {
    const idFromUrl = searchParams.get("id");
    if (idFromUrl && !isNaN(parseInt(idFromUrl, 10))) {
      const listingId = parseInt(idFromUrl, 10);
      dispatch(setActiveListingId(listingId));

      if (window.history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.delete("id");
        window.history.replaceState({}, "", url.pathname);
      }
    }
  }, [searchParams, dispatch]);

  useEffect(() => {
    dispatch(fetchAllBankingListings());
  }, [dispatch]);

  const handleSelfListingFilter = (filter, listings) => {
    setActiveFilter(filter);
    setFilteredSelfListings(listings);
  };

  const handleSortChange = () => {
    if (!expirySortDir) {
      setExpirySortDir("asc");
    } else if (expirySortDir === "asc") {
      setExpirySortDir("desc");
    } else {
      setExpirySortDir(null);
    }
  };

  const handleApplyFilters = (filterData) => {
    if (activeListingId) {
      setAppliedFiltersMap((prev) => ({
        ...prev,
        [activeListingId]: filterData,
      }));
    }
  };

  const handleAvailableCountChange = (count) => {
    setFilteredAvailableCount(count);
  };

  return (
    <div className={Styles.outerWrapper}>
      {/* {showDamStrip && <DamStrip />} */}
      <div className={Styles.bankingMain}>
        <div className={Styles.availableHeaderCont}>
          <div className={Styles.elemHeader}>
            <SelfHeader
              filteredListings={filteredSelfListings}
              activeFilter={activeFilter}
            />
          </div>
          <div className={`scroll_bar_x ${Styles.selfListingContainer}`}>
            <SelfListing onFilterChange={handleSelfListingFilter} />
          </div>
        </div>
        <div>
          <div className={Styles.elemHeader}>
            <AvailableHeader
              onSortChange={handleSortChange}
              currentSort={expirySortDir}
              onApplyFilters={handleApplyFilters}
              appliedFilters={appliedFilters}
              filteredCount={filteredAvailableCount}
            />
          </div>
          <div className={`scroll_bar_x ${Styles.availableListingContainer}`}>
            <AvailableListing
              expirySortDir={expirySortDir}
              selfListings={filteredSelfListings}
              filteredSelfListings={filteredSelfListings}
              activeFilter={activeFilter}
              appliedFilters={appliedFilters}
              onCountChange={handleAvailableCountChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankingMain;
